export default __webpack_public_path__ + "static/CookieRun-Regular.subset-e80559b851d63f5325b773565bdea8f4.woff2";